import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { LandingDesign1Component } from './designs/landing-design-1/landing-design-1.component';
import { LandingDesign2Component } from './designs/landing-design-2/landing-design-2.component';
import { LandingDesign3Component } from './designs/landing-design-3/landing-design-3.component';
import { LandingDesign4Component } from './designs/landing-design-4/landing-design-4.component';
import { LandingDesign5Component } from './designs/landing-design-5/landing-design-5.component';
import { LandingHeroComponent } from './designs/shared/landing-hero/landing-hero.component';
import { LandingCompactCardComponent } from './designs/shared/landing-compact-card/landing-compact-card.component';
import { CommonsModule } from '../../commons/commons.module';


@NgModule({
  declarations: [
    LandingComponent,
    LandingDesign1Component,
    LandingDesign2Component,
    LandingDesign3Component,
    LandingDesign4Component,
    LandingDesign5Component,
    LandingHeroComponent,
    LandingCompactCardComponent
  ],
  imports: [
    CommonModule,
    CommonsModule
  ]
})
export class LandingModule { }
